module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only ParaOverride-1",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-US"
    }
  }, [_vm._v("TABLET I")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He who has seen everything, I will make known (?) to the lands.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I will teach (?) about him who experienced all things,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("… alike,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Anu granted him the totality of knowledge of all.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He saw the Secret, discovered the Hidden,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he brought information of (the time) before the Flood.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He went on a distant journey, pushing himself to exhaustion,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("but then was brought to peace.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He carved on a stone stela all of his toils,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and built the wall of Uruk-Haven,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the wall of the sacred Eanna Temple, the holy sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Look at its wall which gleams like copper(?),")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("inspect its inner wall, the likes of which no one can equal!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Take hold of the threshold stone—it dates from ancient times!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Go close to the Eanna Temple, the residence of Ishtar,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("such as no later king or man ever equaled!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Go up on the wall of Uruk and walk around,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("examine its foundation, inspect its brickwork thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Is not (even the core of) the brick structure made of kiln-fired brick,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and did not the Seven Sages themselves lay out its plans?")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("One league city, one league palm gardens, one league lowlands, the open area(?) of the Ishtar Temple,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("three leagues and the open area(?) of Uruk it (the wall) encloses.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Find the copper tablet box,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("open the … of its lock of bronze,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("undo the fastening of its secret opening.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Take and read out from the lapis lazuli tablet")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("how Gilgamesh went through every hardship.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Supreme over other kings, lordly in appearance,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he is the hero, born of Uruk, the goring wild bull.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He walks out in front, the leader,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and walks at the rear, trusted by his companions.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Mighty net, protector of his people,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("raging flood-wave who destroys even walls of stone!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Offspring of Lugalbanda, Gilgamesh is strong to perfection,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("son of the august cow, Rimat-Ninsun; … Gilgamesh is awesome to perfection.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was he who opened the mountain passes,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("who dug wells on the flank of the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was he who crossed the ocean, the vast seas, to the rising sun,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("who explored the world regions, seeking life.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was he who reached by his own sheer strength Utanapishtim, the Faraway,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("who restored the sanctuaries (or: cities) that the Flood had destroyed!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("… for teeming mankind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Who can compare with him in kingliness?")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Who can say like Gilgamesh: “I am King!”?")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Whose name, from the day of his birth, was called “Gilgamesh”?")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Two-thirds of him is god, one-third of him is human.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Great Goddess [Aruru] designed(?) the model for his body,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("she prepared his form …")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("… beautiful, handsomest of men,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("… perfect")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("…")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He walks around in the enclosure of Uruk,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Like a wild bull he makes himself mighty, head raised (over others).")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is no rival who can raise his weapon against him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His fellows stand (at the alert), attentive to his (orders ?),")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and the men of Uruk become anxious in …")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gilgamesh does not leave a son to his father,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("day and night he arrogant[y(?) …")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("[The following lines are interpreted as rhetorical, perhaps spoken by the oppressed citizens of Uruk.]")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Is Gilgamesh the shepherd of Uruk-Haven,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("is he the shepherd… .")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("bold, eminent, knowing, and wise!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gilgamesh does not leave a girl to her mother(?)")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The daughter of the warrior, the bride of the young man,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the gods kept hearing their complaints, so")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the gods of the heavens implored the Lord of Uruk [Anu]")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You have indeed brought into being a mighty wild bull, head raised!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There is no rival who can raise a weapon against him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“His fellows stand (at the alert), attentive to his (orders !),")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Gilgamesh does not leave a son to his father,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“day and night he arrogantly …")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is he the shepherd of Uruk-Haven,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“is he their shepherd …")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“bold, eminent, knowing, and wise,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Gilgamesh does not leave a girl to her mother(?)!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The daughter of the warrior, the bride of the young man,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Anu listened to their complaints,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and (the gods) called out to Aruru:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“it was you, Aruru, who created mankind(?),")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("now create a zikru to it/him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Let him be equal to his (Gilgamesh’s) stormy heart,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("let them be a match for each other so that Uruk may find peace!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When Aruru heard this she created within herself the zikrtt of Anu.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Aruru washed her hands, she pinched off some clay, and threw it into the wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the wildness(?) she created valiant Enkidu,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("born of Silence, endowed with strength by Ninurta.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His whole body was shaggy with hair,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he had a full head of hair like a woman,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("his locks billowed in profusion like Ashnan.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He knew neither people nor settled living,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("but wore a garment like Sumukan.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He ate grasses with the gazelles,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and jostled at the watering hole with the animals;")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("as with animals, his thirst was slaked with (mere) water.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A notorious trapper came face-to-face with him opposite the watering hole.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A first, a second, and a third day")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he came face-to-face with him opposite the watering hole.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On seeing him the trapper’s face went stark with fear,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and he (Enkidu?) and his animals drew back home.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was rigid with fear; though stock-still")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("his heart pounded and his face drained of color.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was miserable to the core,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and his face looked like one who had made a long journey.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The trapper addressed his father saying:”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Father, a certain fellow has come from the mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He is the mightiest in the land,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("his strength is as mighty as the meteorite(?) of Anu!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He continually goes over the mountains,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he continually jostles at the watering place with the animals,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he continually plants his feet opposite the watering place.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was afraid, so I did not go up to him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He filled in the pits that I had dug,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("wrenched out my traps that I had spread,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("released from my grasp the wild animals.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He does not let me make my rounds in the wilderness!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The trapper’s father spoke to him saying:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My son, there lives in Uruk a certain Gilgamesh.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is no one stronger than he,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he is as strong as the meteorite(?) of Anu.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Go, set off to Uruk,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("tell Gilgamesh of this Man of Might.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He will give you the harlot Shamhat, take her with you.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The woman will overcome the fellow (?) as if she were strong.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When the animals are drinking at the watering place")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("have her take off her robe and expose her sex.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When he sees her he will draw near to her,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and his animals, who grew up in his wilderness, will be alien to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He heeded his father’s advice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The trapper went off to Uruk,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he made the journey, stood inside of Uruk,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and declared to … Gilgamesh:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There is a certain fellow who has come from the mountains—")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he is the mightiest in the land,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("his strength is as mighty as the meteorite(?) of Anu!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He continually goes over the mountains,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he continually jostles at the watering place with the animals,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he continually plants his feet opposite the watering place.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was afraid, so I did not go up to him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He filled in the pits that I had dug,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("wrenched out my traps that I had spread,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("released from my grasp the wild animals.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He does not let me make my rounds in the wilderness!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gilgamesh said to the trapper:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Go, trapper, bring the harlot, Shamhat, with you.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When the animals are drinking at the watering place")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("have her take off her robe and expose her sex.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When he sees her he will draw near to her,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and his animals, who grew up in his wilderness, will be alien to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The trapper went, bringing the harlot, Shamhat, with him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They set off on the journey, making direct way.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On the third day they arrived at the appointed place,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and the trapper and the harlot sat down at their posts(?).")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A first day and a second they sat opposite the watering hole.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The animals arrived and drank at the watering hole,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the wild beasts arrived and slaked their thirst with water.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then he, Enkidu, offspring of the mountains,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("who eats grasses with the gazelles,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("came to drink at the watering hole with the animals,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("with the wild beasts he slaked his thirst with water.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then Shamhat saw him—a primitive,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("a savage fellow from the depths of the wilderness!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That is he, Shamhat! Release your clenched arms,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("expose your sex so he can take in your voluptuousness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Do not be restrained—take his energy!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When he sees you he will draw near to you.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Spread out your robe so he can lie upon you,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and perform for this primitive the task of womankind!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His animals, who grew up in his wilderness, will become alien to him,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and his lust will groan over you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Shamhat unclutched her bosom, exposed her sex, and he took in her voluptuousness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She was not restrained, but took his energy.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She spread out her robe and he lay upon her,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("she performed for the primitive the task of womankind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His lust groaned over her;")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("for six days and seven nights Enkidu stayed aroused,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and had intercourse with the harlot")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("until he was sated with her charms.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But when he turned his attention to his animals,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the gazelles saw Enkidu and darted off,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the wild animals distanced themselves from his body.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Enkidu … his utterly depleted(?) body,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("his knees that wanted to go off with his animals went rigid;")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Enkidu was diminished, his running was not as before.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But then he drew himself up, for his understanding had broadened.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Turning around, he sat down at the harlot’s feet,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("gazing into her face, his ears attentive as the harlot spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The harlot said to Enkidu:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You are beautiful,” Enkidu, you are become like a god.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Why do you gallop around the wilderness with the wild beasts?")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Come, let me bring you into Uruk-Haven,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("to the Holy Temple, the residence of Anu and Ishtar,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the place of Gilgamesh, who is wise to perfection,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("but who struts his power over the people like a wild bull.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What she kept saying found favor with him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Becoming aware of himself, he sought a friend.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Enkidu spoke to the harlot:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come, Shamhat, take me away with you")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("to the sacred Holy Temple, the residence of Anu and Ishtar,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the place of Gilgamesh, who is wise to perfection,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("but who struts his power over the people like a wild bull.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I will challenge him …")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Let me shout out in Uruk: I am the mighty one!’")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lead me in and I will change the order of things;")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he whose strength is mightiest is the one born in the wilderness!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("[Shamhat to Enkidu:]")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come, let us go, so he may see your face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I will lead you to Gilgamesh—I know where he will be.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Look about, Enkidu, inside Uruk-Haven,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("where the people show off in skirted finery,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("where every day is a day for some festival,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("where the lyre(?) and drum play continually,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("where harlots stand about prettily,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("exuding voluptuousness, full of laughter")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and on the couch of night the sheets are spread (!).”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Enkidu, you who do not know, how to live,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I will show you Gilgamesh, a man of extreme feelings (!).")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Look at him, gaze at his face—")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he is a handsome youth, with freshness(!),")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("his entire body exudes voluptuousness")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He has mightier strength than you,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("without sleeping day or night!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Enkidu, it is your wrong thoughts you must change!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It is Gilgamesh whom Shamhat loves,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and Anu, Enlil, and La have enlarged his mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Even before you came from the mountain")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gilgamesh in Uruk had dreams about you.”“")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gilgamesh got up and revealed the dream, saying to his mother:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mother, I had a dream last night.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Stars of the sky appeared,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and some kind of meteorite(?) of Anu fell next to me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I tried to lift it but it was too mighty for me,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I tried to turn it over but I could not budge it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Land of Uruk was standing around it,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the whole land had assembled about it,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the populace was thronging around it,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the Men clustered about it,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and kissed its feet as if it were a little baby (!).")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I loved it and embraced it as a wife.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I laid it down at your feet,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and you made it compete with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The mother of Gilgamesh, the wise, all-knowing, said to her Lord;")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rimat-Ninsun, the wise, all-knowing, said to Gilgamesh:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As for the stars of the sky that appeared")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and the meteorite(?) of Anu which fell next to you,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you tried to lift but it was too mighty for you,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you tried to turn it over but were unable to budge it,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you laid it down at my feet,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and I made it compete with you,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and you loved and embraced it as a wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There will come to you a mighty man, a comrade who saves his friend—")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("he is the mightiest in the land, he is strongest,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("his strength is mighty as the meteorite(!) of Anu!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You loved him and embraced him as a wife;")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and it is he who will repeatedly save you.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Your dream is good and propitious!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A second time Gilgamesh said to his mother: “Mother, I have had another dream:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“At the gate of my marital chamber there lay an axe,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“and people had collected about it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The Land of Uruk was standing around it,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“the whole land had assembled about it,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“the populace was thronging around it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I laid it down at your feet,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I loved it and embraced it as a wife,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“and you made it compete with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The mother of Gilgamesh, the wise, all-knowing, said to her son;")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rimat-Ninsun, the wise, all-knowing, said to Gilgamesh:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("““The axe that you saw (is) a man.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“… (that) you love him and embrace as a wife,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“but (that) I have compete with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("““ There will come to you a mighty man,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("““ a comrade who saves his friend—")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“he is the mightiest in the land, he is strongest,")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“he is as mighty as the meteorite(!) of Anu!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gilgamesh spoke to his mother saying:")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("““By the command of Enlil, the Great Counselor, so may it to pass!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“May I have a friend and adviser, a friend and adviser may I have!")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You have interpreted for me the dreams about him!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After the harlot recounted the dreams of Gilgamesh to Enkidu")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("the two of them made love.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cfa3534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled151.vue
// module id = 66
// module chunks = 0